module.exports = __webpack_public_path__ + "img/footer-pizzaking-cj-icon.816f54a3.png";